import React, { useEffect, useState } from 'react';
import message_read from '../../../../assets/Main/message_read.svg';
import message_unread from '../../../../assets/Main/message_unread.svg';
import upload from '../../../../assets/Main/chat_upload.svg';
import {
  formatTimeMoscow,
  formatMessageDate,
  getMessageDateKey,
} from './chatHelpers';

const ChatMessages = ({
  messages,
  messagesLoading,
  messagesRef,
  renderAttachments,
  isExecutor,
  showContactsMessage,
  contactsShared,
  showActionButtons,
  handleShareContacts,
  handleDeclineContacts,
  showReview,
  userRole,
  setModalShowReview,
  scrollThumbPosition,
  showScrollbar,
  handleTrackClick,
  handleThumbMouseDown,
  fileInputRef,
  handleFileChange,
  messageInput,
  setMessageInput,
  handleSend,
  files,
  setFiles,
  customerProfile,
  collaborationState,
  sharingContacts,
  showCustomerContactsButton,
  onShareCustomerContacts,
  onShareExecutorContacts,
  showClosedOrderBanner,
}) => {
  
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1023);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1023);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Функция для получения имени отправителя
  const getSenderName = (msg) => {
    if (msg.mine) return null; 
    
    if (msg.senderRole === 'STAFF') {
      return 'Администратор';
    }
    
    return null; 
  };

  const handleShareExecutorContacts = async () => {
    await onShareExecutorContacts();
  };

  const handleShareCustomerContacts = async () => {
    await onShareCustomerContacts();
  };

  return (
    <>
      <div className="messages-container">
        <div className="messages" ref={messagesRef}>
          {messagesLoading && <div className="loading-messages">Загрузка сообщений...</div>}

          {messages.map((msg, index) => {
            const currentDate = getMessageDateKey(msg.createdAt);
            const prevDate = index > 0 ? getMessageDateKey(messages[index - 1].createdAt) : null;
            const showDateSeparator = currentDate !== prevDate;
            const senderName = getSenderName(msg);

            return (
              <React.Fragment key={msg.id}>
                {showDateSeparator && (
                  <div className="date-separator">{formatMessageDate(msg.createdAt)}</div>
                )}

                <div className={`message ${msg.mine ? 'mine' : 'other'}`}>
                  {/* Имя отправителя для сообщений от других (кроме администратора) */}
                  {!msg.mine && senderName && (
                    <div 
                      className="message-sender-name"
                      style={{
                        fontSize: '12px',
                        fontWeight: '500',
                        color: msg.senderRole === 'STAFF' ? '#DE5A2B' : '#8c8c8c',
                        marginBottom: '4px',
                      }}
                    >
                      {senderName}
                    </div>
                  )}
                  
                  {msg.text && <div className="message-text">{msg.text}</div>}
                  {msg.attachments?.length > 0 && renderAttachments(msg.attachments)}

                  <div
                    className={`message-meta-row ${
                      msg.attachments?.length > 0 ? 'with-attachments' : ''
                    }`}
                  >
                    <div className="message-time">{formatTimeMoscow(msg.createdAt)}</div>
                    {msg.mine && (
                      <img
                        src={msg.read ? message_read : message_unread}
                        alt=""
                        className={msg.read ? 'message-read-status done' : 'message-read-status'}
                      />
                    )}
                  </div>
                </div>
              </React.Fragment>
            );
          })}

          {/* ПЛАШКА ДЛЯ ИСПОЛНИТЕЛЯ ПРИ ЗАКРЫТОМ ЗАКАЗЕ - с прежними стилями как у review-section */}
          {showClosedOrderBanner && userRole === 'EXECUTOR' && (
            <div className="review-section">
              <div className="message other">
                <div
                  className="message-text"
                  style={{ fontWeight: 'bold', paddingBottom: '20px' }}
                >
                  Заказ завершён
                </div>
                <div className="message-time" style={{ marginRight: '10px' }}>
                  {new Date().toLocaleTimeString('ru-RU', {
                    hour: '2-digit',
                    minute: '2-digit',
                  })}
                </div>
              </div>

              <div className="message other review-message">
                <div className="message-text" style={{ paddingBottom: '20px' }}>
                  Расскажите, как прошла сделка, что понравилось, а что нет.
                  <br />
                  <br />
                  Вы можете оценить следующие критерии:
                  <br />• коммуникация;
                  <br />• добросовестность;
                  <br />• общее впечатление
                  <button className="review-button" onClick={() => setModalShowReview(true)}>
                    Оставить отзыв
                  </button>
                </div>
                <div className="message-time" style={{ marginRight: '10px' }}>
                  {new Date().toLocaleTimeString('ru-RU', {
                    hour: '2-digit',
                    minute: '2-digit',
                  })}
                </div>
              </div>
            </div>
          )}

          {/* Сообщение для исполнителя, когда заказчик поделился контактами */}
          {collaborationState?.customerPhoneShared && isExecutor && (
            <div className="message other" style={{ paddingBottom: '30px' }}>
              <div className="message-text">
                <div style={{ fontWeight: 'bold', marginBottom: '10px' }}>Заказчик выбрал вас!</div>
                <div style={{ marginBottom: '5px' }}>Контакты заказчика:</div>
                <div style={{ marginBottom: '5px' }}>
                  • {collaborationState.customerPhone || customerProfile?.phone || 'Телефон не указан'}
                </div>
                
                {!collaborationState?.executorSocialsShared && (
                  <div className="contacts-actions" style={{ marginTop: '15px' }}>
                    <button
                      onClick={handleShareExecutorContacts}
                      className="header-action-accept"
                      style={{ flex: 1, lineHeight: '1.1' }}
                      disabled={sharingContacts}
                    >
                      {sharingContacts ? 'Отправка..' : 'Поделиться моими контактами'}
                    </button>
                    <button
                      onClick={handleDeclineContacts}
                      className="header-action-decline"
                      style={{ flex: 1, background: '#fafafa' }}
                    >
                      Отклонить
                    </button>
                  </div>
                )}
              </div>
              <div className="message-time" style={{ paddingRight: '10px' }}>
                {new Date().toLocaleTimeString('ru-RU', {
                  hour: '2-digit',
                  minute: '2-digit',
                })}
              </div>
            </div>
          )}

          {/* Сообщение с контактами исполнителя (для заказчика) */}
          {collaborationState?.executorSocialsShared && !isExecutor && (
            <div className="message other">
              <div className="message-text">
                <div style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                  Исполнитель поделился контактами
                </div>
                <div style={{ marginBottom: '5px' }}>
                  {collaborationState?.executorSocials?.map((social, index) => {
                    const isLink =
                      social.type === 'TELEGRAM' ||
                      social.type === 'WHATSAPP' ||
                      String(social.value).startsWith('http');

                    return (
                      <div key={index} style={{ marginBottom: '5px' }}>
                        {social.type === 'TELEGRAM' && 'Telegram: '}
                        {social.type === 'WHATSAPP' && 'WhatsApp: '}
                        • {social.type === 'PHONE' && 'Телефон: '}
                        {social.type === 'EMAIL' && 'Email: '}

                        {isLink ? (
                          <a href={social.value} target="_blank" rel="noopener noreferrer">
                            {social.value}
                          </a>
                        ) : (
                          <span>{social.value}</span>
                        )}
                      </div>
                    );
                  })}
                </div>
                
                {!collaborationState?.customerPhoneShared && showCustomerContactsButton && (
                  <div className="contacts-actions" style={{ marginTop: '15px' }}>
                    <button
                      onClick={handleShareCustomerContacts}
                      className="header-action-accept"
                      style={{ flex: 1 }}
                    >
                      Поделиться моими контактами
                    </button>
                  </div>
                )}
              </div>
              <div className="message-time">
                {new Date().toLocaleTimeString('ru-RU', {
                  hour: '2-digit',
                  minute: '2-digit',
                })}
              </div>
            </div>
          )}

          {/* Я поделился контактами (для исполнителя) */}
          {collaborationState?.executorSocialsShared && isExecutor && (
            <div className="message mine" style={{ paddingBottom: '10px' }}>
              <div className="message-text">
                <div style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                  Вы поделились контактами
                </div>

                {collaborationState.executorSocials?.map((social, index) => {
                  const isLink =
                    social.type === 'TELEGRAM' ||
                    social.type === 'WHATSAPP' ||
                    String(social.value).startsWith('http');

                  return (
                    <div key={index} style={{ marginBottom: '5px' }}>
                      {social.type === 'TELEGRAM' && 'Telegram: '}
                      {social.type === 'WHATSAPP' && 'WhatsApp: '}
                      • {social.type === 'PHONE' && 'Телефон: '}
                      {social.type === 'EMAIL' && 'Email: '}

                      {isLink ? (
                        <a href={social.value} target="_blank" rel="noopener noreferrer">
                          {social.value}
                        </a>
                      ) : (
                        <span>{social.value}</span>
                      )}
                    </div>
                  );
                })}
              </div>

              <div className="message-time">
                {new Date().toLocaleTimeString('ru-RU', {
                  hour: '2-digit',
                  minute: '2-digit',
                })}
              </div>
            </div>
          )}

          {/* Я поделился контактами (для заказчика) */}
          {collaborationState?.customerPhoneShared && !isExecutor && (
            <div className="message mine" style={{ paddingBottom: '10px' }}>
              <div className="message-text">
                <div style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                  Вы поделились контактами
                </div>

                <div>
                  • {collaborationState.customerPhone || 'Телефон не указан'}
                </div>
              </div>

              <div className="message-time">
                {new Date().toLocaleTimeString('ru-RU', {
                  hour: '2-digit',
                  minute: '2-digit',
                })}
              </div>
            </div>
          )}

          {/* Сообщение о выборе исполнителя */}
          {collaborationState?.selectedExecutorId && 
           !collaborationState?.customerPhoneShared && 
           !collaborationState?.executorSocialsShared && (
            <div className="message other">
              <div className="message-text">
                <div style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                  Исполнитель выбран!
                </div>
                <div style={{ marginBottom: '5px' }}>
                  Вы можете обменяться контактами
                </div>
              </div>
              <div className="message-time">
                {new Date().toLocaleTimeString('ru-RU', {
                  hour: '2-digit',
                  minute: '2-digit',
                })}
              </div>
            </div>
          )}

          {showReview && (
            <div className="review-section">
              <div className="message other">
                <div
                  className="message-text"
                  style={{ fontWeight: 'bold', paddingBottom: '20px' }}
                >
                  Оставьте отзыв об исполнителе.
                </div>
                <div className="message-time" style={{ marginRight: '10px' }}>
                  {new Date().toLocaleTimeString('ru-RU', {
                    hour: '2-digit',
                    minute: '2-digit',
                  })}
                </div>
              </div>

              <div className="message other review-message">
                <div className="message-text" style={{ paddingBottom: '20px' }}>
                  Расскажите, как прошла сделка, что понравилось, а что нет.
                  <br />
                  <br />
                  Вы можете оценить следующие критерии:
                  {userRole === 'CUSTOMER' ? (
                    <>
                      <br />• качество работы;
                      <br />• соблюдение сроков;
                      <br />• соблюдение бюджета
                    </>
                  ) : (
                    <>
                      <br />• коммуникация;
                      <br />• добросовестность;
                      <br />• общее впечатление
                    </>
                  )}
                  <button className="review-button" onClick={() => setModalShowReview(true)}>
                    Оставить отзыв
                  </button>
                </div>
                <div className="message-time" style={{ marginRight: '10px' }}>
                  {new Date().toLocaleTimeString('ru-RU', {
                    hour: '2-digit',
                    minute: '2-digit',
                  })}
                </div>
              </div>
            </div>
          )}
        </div>

        {showScrollbar && (
          <div className="custom-scrollbar">
            <div className="scroll-track" onClick={handleTrackClick}>
              <div
                className="scroll-thumb"
                style={{ transform: `translateY(${scrollThumbPosition}px)` }}
                onMouseDown={handleThumbMouseDown}
              />
            </div>
          </div>
        )}
      </div>

      <div className="input-area" style={isMobile ? { marginBottom: '170px' } : {}}>
        <button
          className="attach-button"
          onClick={() => fileInputRef.current?.click()}
          type="button"
        >
          <img src={upload} alt="Вложение" />
        </button>

        <input
          ref={fileInputRef}
          type="file"
          multiple
          onChange={handleFileChange}
          style={{ display: 'none' }}
          accept="image/*,.pdf,.doc,.docx,.txt"
        />

        <input
          className="message-input"
          value={messageInput}
          onChange={(e) => setMessageInput(e.target.value)}
          placeholder="Сообщение"
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              handleSend();
            }
          }}
        />

        <button className="send-button" onClick={handleSend}>
          Отправить
        </button>
      </div>

      {files.length > 0 && (
        <div className="selected-files">
          {files.map((file, index) => (
            <div key={index} className="selected-file">
              <span className="selected-file-name">{file.name}</span>
              <button
                onClick={() => setFiles(files.filter((_, i) => i !== index))}
                className="selected-file-remove"
                type="button"
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default ChatMessages;
